import { memo, useMemo } from 'react';
import { HERO } from '@aleaces/engine';
import { heroSVG } from '../heroSvg';

/** Memoised: portraits are static per hero/skin, but sit inside the seat
 * layout that re-renders with every table snapshot. */
export const Portrait = memo(function Portrait({ heroId, skinId, frame, size }: { heroId: string; skinId?: string; frame?: string; size?: number }) {
  const svg = useMemo(() => {
    const h = HERO[heroId];
    return h ? heroSVG(h, skinId) : '';
  }, [heroId, skinId]);
  const style = size ? { width: size, height: size } : undefined;
  return <div className={'portrait frame-' + (frame ?? 'wood')} style={style} dangerouslySetInnerHTML={{ __html: svg }} />;
});
